import React, { useCallback, useEffect, useRef, useState } from 'react';
import p from '../../styles/renewal/OnePage.module.css';
import OnePageHeader from './OnePageHeader';
import OnePageFooter from './OnePageFooter';
import Hero from './Hero';
import About from './About';
import Voices from './Voices';
import Process from './Process';
import Cases from './Cases';
import FaqNotice from './FaqNotice';
import Partner from './Partner';
import Contact from './Contact';
import Floating from './Floating';
import useEstimate from './useEstimate';
import useReveal from './useReveal';

/**
 * 시안 결합본의 D-원페이지를 옮긴 메인 화면.
 * 앵커 이동 오프셋은 CSS 의 scroll-margin-top(.anchor) 이 처리한다.
 */
const OnePage = () => {
  const estimate = useEstimate();
  const revealRef = useReveal();

  // 푸터가 화면에 들어오면 우하단 고정 버튼이 푸터 연락처를 가리므로 잠시 숨긴다.
  const footerRef = useRef(null);
  const [footerVisible, setFooterVisible] = useState(false);

  useEffect(() => {
    const el = footerRef.current;
    if (!el || typeof IntersectionObserver === 'undefined') return undefined;
    const io = new IntersectionObserver(([entry]) => setFooterVisible(entry.isIntersecting), {
      threshold: 0.01,
    });
    io.observe(el);
    return () => io.disconnect();
  }, []);

  const go = useCallback((id) => {
    const el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, []);

  return (
    <div className={p.page}>
      <OnePageHeader onNavigate={go} />

      <main ref={revealRef}>
        <div className={p.anchor} id="home" />
        <Hero estimate={estimate} onNavigate={go} />

        {/* 섹션 순서는 헤더 메뉴(NAV) 순서와 같게 둔다. */}
        <div className={p.anchor} id="about" />
        <About />
        <Voices />

        <div className={p.anchor} id="guide" />
        <Process onNavigate={go} />

        <div className={p.anchor} id="partner" />
        <Partner />

        <div className={p.anchor} id="cases" />
        <Cases />

        {/* '소식' 메뉴도 이 앵커로 온다 — 새로운 소식은 FAQ 섹션 우측 칸에 있다. */}
        <div className={p.anchor} id="faq" />
        <FaqNotice />

        <div className={p.anchor} id="contact" />
        <Contact />
      </main>

      <Floating onNavigate={go} hidden={footerVisible} />

      <div ref={footerRef}>
        <OnePageFooter onNavigate={go} />
      </div>
    </div>
  );
};

export default OnePage;
